// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1cr-L","boxTitle":"Qualiphy_boxTitle__HyC97","box":"Qualiphy_box__33RzH","toggleWrap":"Qualiphy_toggleWrap__1S7sp"};